var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _g2, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _g3, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErpInstitution(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 431,
    viewBox: "0 0 530 431",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_293_23485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M519.625 245.499C519.625 331.122 405.638 400.461 265.036 400.461C124.411 400.461 10.458 331.111 10.458 245.499C10.458 159.875 124.411 90.5146 265.036 90.5146C405.638 90.5146 519.625 159.875 519.625 245.499Z",
    fill: "#F7F7F7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M264.245 176.94L375.527 237.729",
    stroke: "#202C2C",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M300.568 158.784L411.839 219.574",
    stroke: "#202C2C",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M387.95 122.562L336.689 149.823L436.606 203.9L487.989 177.029L387.95 122.562Z",
    fill: "#202C2C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M487.532 167.367V176.806L460.026 174.491L487.532 167.367Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M391.734 124.477L350.959 145.972L446.757 198.301L487.532 176.806L391.734 124.477Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M446.757 198.301V173.032L350.959 136.532V145.972L446.757 198.301Z",
    fill: "#E2E2E2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M391.734 115.037L350.959 136.532L446.757 188.862L487.532 167.367L391.734 115.037Z",
    fill: "#BFC0C2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M487.532 167.367V176.806L460.026 174.491L487.532 167.367Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M391.734 124.477L350.959 145.972L446.757 198.301L487.532 176.806L391.734 124.477Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M446.757 198.301V173.032L350.959 136.532V145.972L446.757 198.301Z",
    fill: "#E2E2E2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M391.734 115.037L350.959 136.532L446.757 188.862L487.532 167.367L391.734 115.037Z",
    fill: "#BFC0C2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M378.578 48.2927C371.899 48.2927 366.489 51.3316 366.489 55.083V119.323V126.937V131.49C366.489 135.241 371.899 138.28 378.578 138.28C385.256 138.28 390.666 135.241 390.666 131.49V126.937V119.323V55.083C390.655 51.3316 385.245 48.2927 378.578 48.2927Z",
    fill: "#FFFDFE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M370.696 55.751V130.911",
    stroke: "#E2E2E2",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M376.874 59.7473V134.907",
    stroke: "#E2E2E2",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M384.5 56.8418V132.002",
    stroke: "#E2E2E2",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M457.366 87.8762C450.687 87.8762 445.277 90.9151 445.277 94.6664V158.906V166.52V171.073C445.277 174.825 450.687 177.863 457.366 177.863C464.045 177.863 469.455 174.825 469.455 171.073V166.52V158.906V94.6664C469.455 90.9151 464.045 87.8762 457.366 87.8762Z",
    fill: "#FFFDFE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M449.496 95.3345V170.494",
    stroke: "#E2E2E2",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M455.674 99.3193V174.49",
    stroke: "#E2E2E2",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M463.299 96.4143V171.585",
    stroke: "#E2E2E2",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M416.703 68.9973C410.024 68.9973 404.614 72.0362 404.614 75.7875V140.028V147.641V152.194C404.614 155.946 410.024 158.985 416.703 158.985C423.381 158.985 428.791 155.946 428.791 152.194V147.641V140.028V75.7875C428.78 72.0362 423.37 68.9973 416.703 68.9973Z",
    fill: "#FFFDFE"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M408.833 76.4441V151.615",
    stroke: "#E2E2E2",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M415 80.4404V155.612",
    stroke: "#E2E2E2",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M422.625 77.5352V152.706",
    stroke: "#E2E2E2",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M487.532 78.4033V87.8428L460.026 85.5275L487.532 78.4033Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M391.734 35.5137L350.959 57.0086L446.757 109.338L487.532 87.8429L391.734 35.5137Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M446.757 109.338V84.0805L350.959 47.5691V57.0086L446.757 109.338Z",
    fill: "#E2E2E2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M391.734 26.074L350.959 47.5689L446.757 99.8982L487.532 78.4032L391.734 26.074Z",
    fill: "#BFC0C2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M436.083 13.1838L394.941 28.4229L360.199 46.122L422.625 60.4705L436.083 13.1838Z",
    fill: "#BFC0C2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M436.083 13.1838L406.918 27.7884L446.836 92.4959L478.951 75.5426L436.083 13.1838Z",
    fill: "#E2E2E2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M446.958 92.4291L407.374 27.4321L360.199 46.1219L446.958 92.4291Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M437.151 83.9358L405.26 31.562L367.613 46.4894L437.151 83.9358Z",
    fill: "#E2E2E2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M132.237 147.141L17.6489 206.728L182.83 297.183L297.417 237.596L132.237 147.141Z",
    fill: "#202C2C"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M140.196 139.315L25.8533 200.249L19.2412 200.828V203.778L182.685 294.789L303.64 230.327L140.196 139.315Z",
    fill: "#BFC0C2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M140.196 136.366L19.2412 200.828L182.685 291.84L303.64 227.377L140.196 136.366Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M149.524 151.594L47.248 205.737",
    stroke: "#A8A8A8",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M163.372 159.375L61.0957 213.518",
    stroke: "#A8A8A8",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M177.208 167.156L74.9316 221.299",
    stroke: "#A8A8A8",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M191.056 174.937L88.7793 229.08",
    stroke: "#A8A8A8",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M204.893 182.717L102.616 236.861",
    stroke: "#A8A8A8",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M218.74 190.498L116.464 244.642",
    stroke: "#A8A8A8",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M232.576 198.279L130.3 252.423",
    stroke: "#A8A8A8",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M246.424 206.06L144.147 260.204",
    stroke: "#A8A8A8",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M260.261 213.841L157.984 267.985",
    stroke: "#A8A8A8",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M274.098 221.622L171.821 275.766",
    stroke: "#A8A8A8",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M261.552 139.338L95.4028 227.889L212.996 292.129L379.145 203.578L261.552 139.338Z",
    fill: "#202C2C"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M271.147 140.851L113.925 224.649L225.196 285.427L382.418 201.641L271.147 140.851Z",
    fill: "#61251D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M271.147 99.3198L113.925 183.118L225.196 243.907L382.418 160.109L271.147 99.3198Z",
    fill: "#00679D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M113.925 183.118V224.649L225.196 285.427V243.239L113.925 183.118Z",
    fill: "#00679D"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M119.235 194.672V223.124L227.044 281.732V252.845L119.235 194.672Z",
    fill: "#16A4EF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M121.862 196.275V220.586L224.951 276.455V251.755L121.862 196.275Z",
    fill: "#A8A8A8"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M108.771 191.422L231.619 258.656",
    stroke: "#A8A8A8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M108.771 194.55L231.619 261.784",
    stroke: "#A8A8A8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M108.771 197.678L231.619 264.912",
    stroke: "#A8A8A8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M108.771 200.806L231.619 268.051",
    stroke: "#A8A8A8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M108.771 203.945L231.619 271.179",
    stroke: "#A8A8A8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M108.771 207.073L231.619 274.307",
    stroke: "#A8A8A8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M108.771 210.201L231.619 277.446",
    stroke: "#A8A8A8",
    strokeMiterlimit: 10
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M377.464 194.349V170.038L382.284 167.445L382.329 167.5V160.109L225.174 243.206V285.405L382.329 201.641V195.229L377.464 194.349Z",
    fill: "#00679D"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M377.464 169.793V198.257L225.296 280.708V251.822L377.464 169.793Z",
    fill: "#16A4EF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M377.464 170.038V194.35L225.43 276.422V251.721L377.464 170.038Z",
    fill: "#EBEBEB"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M390.566 165.174L218.751 258.623",
    stroke: "#A8A8A8",
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M390.566 168.313L218.751 261.751",
    stroke: "#A8A8A8",
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M390.566 171.441L218.751 264.879",
    stroke: "#A8A8A8",
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M390.566 174.569L218.751 268.018",
    stroke: "#A8A8A8",
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M390.566 177.708L218.751 271.146",
    stroke: "#A8A8A8",
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M390.566 180.836L218.751 274.274",
    stroke: "#A8A8A8",
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M390.566 183.964L218.751 277.413",
    stroke: "#A8A8A8",
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M272.884 99.9094L138.827 171.352L233.701 223.191L367.769 151.738L272.884 99.9094Z",
    fill: "#61251D"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M272.884 64.489L138.827 135.942L233.701 187.771L367.769 116.328L272.884 64.489Z",
    fill: "#D88C1F"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M138.827 135.942V171.351L233.701 223.191V187.214L138.827 135.942Z",
    fill: "#945A05"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M143.346 145.793V170.06L235.281 220.03V195.396L143.346 145.793Z",
    fill: "#FAA831"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M145.594 147.163V167.889L233.489 215.521V194.472L145.594 147.163Z",
    fill: "#A8A8A8"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M134.429 143.022L239.188 200.349",
    stroke: "#A8A8A8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M134.429 145.693L239.188 203.021",
    stroke: "#A8A8A8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M134.429 148.365L239.188 205.692",
    stroke: "#A8A8A8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M134.429 151.025L239.188 208.364",
    stroke: "#A8A8A8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M134.429 153.697L239.188 211.035",
    stroke: "#A8A8A8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M134.429 156.369L239.188 213.696",
    stroke: "#A8A8A8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M134.429 159.04L239.188 216.367",
    stroke: "#A8A8A8",
    strokeMiterlimit: 10
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M363.55 145.515V124.788L367.657 122.573L367.691 122.618V116.317L233.689 187.181V223.158L367.691 151.738V146.261L363.55 145.515Z",
    fill: "#945A05"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M363.55 124.588V148.855L233.801 219.15V194.527L363.55 124.588Z",
    fill: "#FAA831"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M363.55 124.788V145.515L233.901 215.499V194.438L363.55 124.788Z",
    fill: "#EBEBEB"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M374.715 120.647L228.213 200.327",
    stroke: "#A8A8A8",
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M374.715 123.319L228.213 202.998",
    stroke: "#A8A8A8",
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M374.715 125.99L228.213 205.659",
    stroke: "#A8A8A8",
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M374.715 128.651L228.213 208.33",
    stroke: "#A8A8A8",
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M374.715 131.323L228.213 211.002",
    stroke: "#A8A8A8",
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M374.715 133.994L228.213 213.673",
    stroke: "#A8A8A8",
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M374.715 136.666L228.213 216.345",
    stroke: "#A8A8A8",
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M245.1 163.371C286.413 163.371 319.904 144.178 319.904 120.503C319.904 96.8282 286.413 77.6357 245.1 77.6357C203.787 77.6357 170.296 96.8282 170.296 120.503C170.296 144.178 203.787 163.371 245.1 163.371Z",
    fill: "#202C2C"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M172.244 43.5845V117.197C172.244 139.883 204.982 158.284 245.367 158.284C285.752 158.284 318.49 139.883 318.49 117.197V43.5845H172.244Z",
    fill: "#202C2C"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M359.164 71.3799V62.4746H341.766L243.141 9.85596L144.515 62.4746H127.117V71.3799V71.7583L243.141 133.661L359.164 71.7583V71.3799Z",
    fill: "#171443"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M359.164 71.3799V62.4746H341.766L243.141 9.85596L144.515 62.4746H127.117V71.3799V71.7583L243.141 133.661L359.164 71.7583V71.3799Z",
    fill: "#324446"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M243.141 0.572266L127.117 62.4746L243.141 124.377L359.164 62.4746L243.141 0.572266Z",
    fill: "#4D6565"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M244.966 57.5549L182.14 91.4838V149.501",
    stroke: "#FAA831",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M187.895 179.144C187.895 182.183 185.424 184.654 182.385 184.654C179.346 184.654 176.875 182.183 176.875 179.144V160.454C176.875 157.415 179.346 154.944 182.385 154.944C185.424 154.944 187.895 157.415 187.895 160.454V179.144Z",
    fill: "#FAA831"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M165.376 155.133C176.541 161.979 190.567 161.767 200.908 153.541C203.858 151.192 199.695 147.085 196.778 149.411C188.507 156.001 177.053 155.433 168.337 150.09C165.098 148.098 162.17 153.162 165.376 155.133Z",
    fill: "#EAAF39"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M189.51 150.035C189.51 153.964 186.315 157.159 182.385 157.159C178.456 157.159 175.261 153.976 175.261 150.035C175.261 146.106 178.445 142.911 182.385 142.911C186.326 142.911 189.51 146.106 189.51 150.035Z",
    fill: "#FFCB58"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M252.313 59.3468C252.313 63.1315 247.271 66.2038 241.048 66.2038C234.826 66.2038 229.783 63.1315 229.783 59.3468C229.783 55.5621 234.826 52.4898 241.048 52.4898C247.271 52.4786 252.313 55.5509 252.313 59.3468Z",
    fill: "#EAAF39"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M249.987 57.51C249.987 60.5155 245.98 62.9533 241.037 62.9533C236.095 62.9533 232.087 60.5155 232.087 57.51C232.087 54.5045 236.095 52.0667 241.037 52.0667C245.98 52.0667 249.987 54.5045 249.987 57.51Z",
    fill: "#FFCB58"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M198.436 238.297L197.936 257.577L204.804 254.794L213.631 266.905V246.634L198.436 238.297Z",
    fill: "#B25900"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M360.187 270.679C359.352 271.124 358.573 271.647 357.861 272.248L362.792 269.643C361.89 269.899 361.022 270.244 360.187 270.679Z",
    fill: "#FF481E"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M447.171 214.211L215.082 337.083L240.155 384.443L472.244 261.571L447.171 214.211Z",
    fill: "#D8D8D8"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M212.15 368.936C219.096 382.049 231.886 388.884 240.713 384.208C249.552 379.533 251.088 365.107 244.142 351.994C237.196 338.881 224.406 332.046 215.578 336.721C206.751 341.408 205.215 355.823 212.15 368.936Z",
    fill: "#BFC0C2"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M212.205 368.914C219.129 381.982 231.874 388.795 240.68 384.13C249.485 379.466 251.01 365.096 244.097 352.027C237.184 338.959 224.428 332.146 215.622 336.81C206.817 341.474 205.292 355.845 212.205 368.914Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M212.085 369.028C219.031 382.141 231.821 388.975 240.648 384.3C249.487 379.625 251.023 365.198 244.077 352.085C237.131 338.973 224.34 332.138 215.513 336.813C206.675 341.488 205.139 355.915 212.085 369.028Z",
    fill: "#F2F2F2"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M222.334 356.19L222.346 356.212C222.39 356.19 222.445 356.168 222.49 356.146L222.334 356.19Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M443.808 246.289C450.754 259.402 463.544 266.237 472.371 261.562C481.21 256.886 482.746 242.46 475.8 229.347C468.854 216.234 456.063 209.399 447.236 214.074C438.398 218.75 436.862 233.176 443.808 246.289Z",
    fill: "#F2F2F2"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M386.202 276.979C379.256 263.866 366.466 257.031 357.639 261.706C357.004 262.04 356.426 262.43 355.869 262.853L304.764 289.914C313.447 287.108 324.901 293.865 331.335 306.021C338.281 319.134 336.745 333.56 327.907 338.235C327.74 338.325 327.573 338.391 327.406 338.48L327.439 338.547L384.299 308.448L384.221 308.303C391.757 302.86 392.748 289.335 386.202 276.979Z",
    fill: "#E13F2A"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M396.543 300.822L396.877 291.116L413.696 287.353L374.625 272.682L357.159 286.04L396.543 300.822Z",
    fill: "#AB0E09"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M413.696 284.893V287.353L405.804 285.261L413.696 284.893Z",
    fill: "#AB0E09"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M396.543 298.362L396.877 288.655L413.696 284.893L374.625 270.222L357.16 283.58L396.543 298.362Z",
    fill: "#FF481E"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M339.405 290.514L325.892 317.13L344.192 312.855L358.095 322.607L366.644 290.815L339.405 290.514Z",
    fill: "#AB0E09"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M325.925 314.236L325.892 317.13L334.708 314.058L336.11 308.18L325.925 314.236Z",
    fill: "#AB0E09"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M339.405 287.643L325.892 314.258L344.192 309.984L358.095 319.735L366.644 287.932L339.405 287.643Z",
    fill: "#FF481E"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M382.028 273.784C382.028 285.049 367.034 294.177 348.522 294.177C330.01 294.177 315.016 285.049 315.016 273.784C315.016 262.519 330.01 253.391 348.522 253.391C367.034 253.391 382.028 262.519 382.028 273.784Z",
    fill: "#AB0E09"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M382.028 271.19C382.028 282.455 367.034 291.583 348.522 291.583C330.01 291.583 315.016 282.455 315.016 271.19C315.016 259.925 330.01 250.797 348.522 250.797C367.034 250.797 382.028 259.925 382.028 271.19Z",
    fill: "#FF481E"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M369.917 269.454C369.917 276.645 360.333 282.477 348.522 282.477C336.701 282.477 327.127 276.645 327.127 269.454C327.127 262.263 336.701 256.43 348.522 256.43C360.344 256.43 369.917 262.263 369.917 269.454Z",
    fill: "#FFBE00"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M376.64 270.322C376.64 279.773 364.05 287.442 348.522 287.442C332.994 287.442 320.404 279.784 320.404 270.322C320.404 260.871 332.994 253.202 348.522 253.202C364.05 253.202 376.64 260.871 376.64 270.322Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M365.642 269.454C365.642 275.209 357.984 279.873 348.533 279.873C339.082 279.873 331.424 275.209 331.424 269.454C331.424 263.699 339.082 259.035 348.533 259.035C357.972 259.035 365.642 263.699 365.642 269.454Z",
    fill: "#FFB001"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M373.935 94.5999L413.085 220.008",
    stroke: "#A7734E",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M342.6 131.223C341.509 131.245 340.452 130.655 339.929 129.609C339.183 128.128 339.784 126.292 341.253 125.501L375.939 106.989C377.431 106.188 379.256 106.756 380.013 108.236C380.77 109.728 380.169 111.576 378.678 112.377L343.936 130.878C343.513 131.1 343.046 131.223 342.6 131.223Z",
    fill: "#805434"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M348.544 150.803C347.442 150.825 346.385 150.224 345.862 149.178C345.116 147.697 345.706 145.85 347.186 145.07L381.961 126.648C383.453 125.857 385.289 126.425 386.046 127.917C386.803 129.408 386.202 131.267 384.699 132.058L349.88 150.458C349.457 150.681 348.99 150.803 348.544 150.803Z",
    fill: "#805434"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M354.734 170.773C353.632 170.806 352.563 170.227 352.018 169.181C351.239 167.701 351.806 165.853 353.276 165.04L387.806 146.072C389.297 145.259 391.145 145.794 391.924 147.285C392.715 148.777 392.147 150.636 390.655 151.46L356.092 170.406C355.647 170.639 355.19 170.762 354.734 170.773Z",
    fill: "#805434"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M360.7 190.476C359.598 190.509 358.519 189.919 357.973 188.873C357.194 187.381 357.762 185.533 359.231 184.732L393.872 165.886C395.364 165.074 397.212 165.63 398.002 167.122C398.793 168.613 398.225 170.483 396.722 171.296L362.036 190.119C361.624 190.342 361.157 190.453 360.7 190.476Z",
    fill: "#805434"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M366.489 209.945C365.376 209.945 364.318 209.344 363.784 208.275C363.027 206.772 363.628 204.925 365.12 204.157L400.195 186.023C401.709 185.244 403.557 185.834 404.314 187.348C405.082 188.862 404.481 190.721 402.967 191.5L367.858 209.611C367.413 209.834 366.945 209.934 366.489 209.945Z",
    fill: "#805434"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M372.51 229.781C371.397 229.781 370.329 229.169 369.794 228.1C369.037 226.586 369.639 224.738 371.13 223.97L406.295 205.926C407.809 205.147 409.656 205.748 410.424 207.273C411.193 208.787 410.58 210.657 409.066 211.425L373.857 229.447C373.434 229.681 372.967 229.781 372.51 229.781Z",
    fill: "#805434"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M336.5 110.618L375.872 238.063",
    stroke: "#A7734E",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M184.076 329.263C183.943 329.197 183.809 329.141 183.676 329.085L176.307 325.223C176.195 325.156 176.084 325.078 175.973 325.011C175.605 324.822 175.216 324.688 174.826 324.577L174.859 324.499L76.3121 272.315C76.1897 272.237 76.0784 272.159 75.9559 272.092C75.4661 271.836 74.943 271.658 74.4087 271.558L74.4532 271.469L50.6206 270.511L62.5425 289.112C62.8875 290.014 63.3773 290.793 64.0229 291.416L64.2345 291.75L64.2901 291.65C64.5795 291.895 64.8912 292.129 65.2363 292.307C65.3587 292.374 65.4812 292.418 65.6036 292.463L164.173 344.647L164.251 344.502C164.563 344.77 164.886 345.014 165.253 345.204C165.42 345.293 165.587 345.371 165.754 345.437L173.056 349.267C173.156 349.334 173.257 349.4 173.357 349.456C177.119 351.448 182.574 348.532 185.523 342.955C188.496 337.4 187.839 331.256 184.076 329.263Z",
    fill: "#202C2C"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7914 265.357L72.4052 286.596L82.6128 266.315L58.7914 265.357Z",
    fill: "#FFCC81"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M121.205 291.05C121.562 291.239 121.895 291.461 122.196 291.717L120.092 290.604C120.482 290.716 120.849 290.86 121.205 291.05Z",
    fill: "#FF481E"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5847 280.653C82.6238 286.241 77.1804 289.146 73.418 287.153C69.6555 285.161 68.9988 279.016 71.9598 273.428C74.9208 267.84 80.3641 264.924 84.1265 266.916C87.889 268.92 88.5346 275.065 85.5847 280.653Z",
    fill: "#00679D"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1549 266.964L73.4724 287.142L172.345 339.487L183.027 319.309L84.1549 266.964Z",
    fill: "#004C74"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M184.277 332.904C181.316 338.492 175.872 341.397 172.11 339.416C168.347 337.423 167.691 331.279 170.652 325.691C173.613 320.103 179.056 317.197 182.818 319.19C186.57 321.171 187.226 327.316 184.277 332.904Z",
    fill: "#BFC0C2"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M192.459 324.233L184.466 320.047C184.355 319.98 184.244 319.902 184.132 319.836C180.37 317.843 174.915 320.759 171.966 326.336C169.005 331.924 169.661 338.069 173.424 340.062C173.591 340.151 173.758 340.217 173.925 340.295L181.772 344.414L192.459 324.233Z",
    fill: "#B67210"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M193.705 337.813C190.744 343.401 185.301 346.306 181.538 344.314C177.776 342.321 177.119 336.177 180.08 330.589C183.041 325.001 188.485 322.095 192.247 324.088C196.009 326.08 196.666 332.225 193.705 337.813Z",
    fill: "#D88C1F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_293_23485",
    x: 0.458008,
    y: 90.5146,
    width: 529.167,
    height: 339.946,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_293_23485"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_293_23485",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErpInstitution);
export default __webpack_public_path__ + "static/media/erpInstitution.62ea0502cf3427122eebf904cc4e8c30.svg";
export { ForwardRef as ReactComponent };